module.exports = __webpack_public_path__ + "static/media/pic_kehu.c3af24d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/pic_kehu.png
// module id = 580
// module chunks = 0